import { gql } from "@apollo/client"

import imageFields from "./partials/imageFields"
import seoFields from "./partials/seoFields"
import sys from "./partials/sys"

export const caseStudiesId = "CaseStudy"
export const caseStudiesCollection = "caseStudyCollection"

const caseStudiesSharedFields = `
  ${sys}
  slug
  title
  heroTitle
  customerDescription
  video{
    videoName
    videoLink
    videoCover {
      ${imageFields}
    }
    wistiaVideo
  }
  whiteLogo {
    ${imageFields}
  }
  quote{
    name
    title
    quoteeImage {
      ${imageFields}
    }
    quote
  }
  seo {
    ${seoFields}
  }
`

export const GET_ALL_CASE_STUDIES_SLUGS_QUERY = gql`
  query InsightsPostsSlugs {
    ${caseStudiesCollection} {
      total
      items {
        slug
      }
    }
  }
`

export const GET_CASE_STUDIES_BYNAME_QUERY = gql`
query GetCaseStudy($customers: [String!]) {
  ${caseStudiesCollection}(
    where: { title_in: $customers }
  ) {
    items {
      title
      slug
      video {
        videoName
        videoLink
        videoCover{
          url
        }
        wistiaVideo
      }
      heroTitle
      statRow
      colorLogo {
        url
      }
      quote {
        name
        title
        company
        quoteeImage {
          url
        }
        quote
      }
    }
  }
}
`

export const GET_CASE_STUDY_QUERY = gql`
  query GetCaseStudy($slug: String!, $preview: Boolean!) {
    ${caseStudiesCollection} (
      where: { slug: $slug }
      preview: $preview
      limit: 1
    ) {
      total
      items{
        ${caseStudiesSharedFields}
        tags
        statRow
        summaryDescription
        summaryTitle
        solution
        goal
      }
    }
  }
`

export const GET_CASE_STUDIES_QUERY = gql`
  query getCaseStudies{
    ${caseStudiesCollection} {
      items{
        ${caseStudiesSharedFields}
      }
    }
  }
`
